<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="90px">
            <el-form-item label="酒店名称" prop="name">
                <el-input v-model="searchForm.name" placeholder="酒店名称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择">
                    <el-option label="待审核" :value="4"></el-option>
                    <el-option label="已审核" :value="5"></el-option>
                    <el-option label="已驳回" :value="6"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center"></el-table-column>
            <el-table-column prop="createTime" label="申请时间" align="center" width="170"></el-table-column>
            <el-table-column prop="name" label="酒店名称" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="statusDesc" label="状态"  width="130">
                <template slot-scope="{ row }">
                    <el-tag type="danger" v-if="row.status == 6">{{ row.statusDesc }}</el-tag>
                    <el-tag v-else>{{ row.statusDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="province" label="省" width="100"></el-table-column>
            <el-table-column prop="city" label="市" width="100"></el-table-column>
            <el-table-column prop="address" label="详细地址" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="landline" label="前台电话" width="120"></el-table-column>
            <el-table-column prop="contact" label="酒店联系人" width="100" ></el-table-column>
            <el-table-column prop="contactPhone" label="联系人电话" width="120"></el-table-column>
            
            <el-table-column label="操作" fixed="right" width="180">
                <template slot-scope="{ row }">
                    <el-button size="mini" type="text" v-if="pagePermission.includes('aduit') && (row.status == 4)" @click="handleEditHotel(row)">审核</el-button>
                    <el-button size="mini" type="text" v-if="pagePermission.includes('view')" @click="handleViewHotel(row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        <el-drawer :title="isAduit ? '审核' : '查看详情'" :visible.sync="isShow" size="950px">
            <div class="detail_header">
                <div class="detail_info">
                    <p>{{ modelForm.name }}的入驻申请</p>
                    <span>申请时间：{{ modelForm.createTime }}</span>
                </div>
                <div class="detail_status">{{ modelForm.statusDesc }}</div>
            </div>
            <el-form ref="modelForm" :model="modelForm" inline label-width="110px" class="model_container"
                style="margin:0 20px" size="small" :rules="modelFormRules">
                <el-divider content-position="left">基础信息</el-divider>
                <el-form-item label="酒店名称" prop="name">
                    <el-input type="text" v-model="modelForm.name" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="所在地" prop="province">
                    <el-input type="text" v-model="modelForm.province" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input type="text" v-model="modelForm.address" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="前台电话" prop="landline">
                    <el-input type="text" v-model="modelForm.landline" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item prop="contact" label="酒店联系人">
                    <el-input v-model="modelForm.contact" disabled placeholder="请输入酒店联系人" style="width: 250px"></el-input>
                </el-form-item>

                <el-form-item prop="contactPhone" label="联系人电话">
                    <el-input v-model="modelForm.contactPhone" disabled placeholder="请输入联系人电话" style="width: 250px"></el-input>
                </el-form-item>
                <div class="line"></div>

                <el-form-item prop="cover" label="酒店封面">
                    <div class="image-uploader" style="width: 250px">
                        <img :src="modelForm.cover" class="avatar">
                    </div>
                </el-form-item>
                <el-form-item prop="wxQrCodeUrl" label="客服微信" v-if="modelForm.identityNationalEmblemUrl">
                    <div class="image-uploader" style="width: 250px">
                        <img :src="modelForm.wxQrCodeUrl" class="avatar">
                    </div>
                </el-form-item>
                <el-form-item prop="detailDiagramUrl" label="详情图">
                    <div class="detail_container" style="width: 250px">
                        <div class="detail_item" v-for="(item, key) in modelForm.detailDiagramUrl" :key="key">
                            <img :src="item" style="width: 150px;" />
                            <div class="image_button">
                                <i class="el-icon-zoom-in" @click="handleShowImage(item)"></i>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                
                <div>
                    <el-divider content-position="left">资质信息</el-divider>
                    <el-form-item prop="businessLicenseUrl" label="营业执照">
                        <div class="image-uploader" style="width: 250px">
                            <img :src="modelForm.businessLicenseUrl" class="avatar">
                        </div>
                    </el-form-item>
                    <el-form-item prop="hasDeadline" label="是否有期限">
                        <el-switch v-model="modelForm.hasDeadline" disabled :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="期限" prop="deadline" v-if="modelForm.hasDeadline == 1">
                        <el-date-picker v-model="modelForm.deadline" disabled format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择执照日期" style="width: 250px"></el-date-picker>
                    </el-form-item>
                    <div class="line"></div>
                    <el-form-item prop="identityPhysiognomyUrl" label="法人身份证正面" v-if="modelForm.identityNationalEmblemUrl">
                        <div class="image-uploader" style="width: 250px">
                            <img :src="modelForm.identityPhysiognomyUrl" class="avatar">
                        </div>
                       
                    </el-form-item>
                    <el-form-item prop="identityNationalEmblemUrl" label="法人身份证反面" v-if="modelForm.identityNationalEmblemUrl">
                        <div class="image-uploader" style="width: 250px">
                            <img :src="modelForm.identityNationalEmblemUrl" class="avatar">
                        </div>
                    </el-form-item>
                </div>

                <div v-if="isAduit">
                    <el-form-item label="审核" prop="status">
                        <el-radio-group v-model="modelForm.status" style="width: 250px">
                            <el-radio :label="5">通过</el-radio>
                            <el-radio :label="6">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="备注" prop="remark" v-if="modelForm.status == 6">
                        <el-input type="textarea" v-model="modelForm.remark" placeholder="请输入驳回备注" style="width: 250px"></el-input>
                    </el-form-item>

                    <el-form-item label="关联账户" prop="username" v-if="modelForm.status == 5">
                        <el-input type="text" v-model="modelForm.username" placeholder="请输入关联账户" style="width: 250px"></el-input>
                    </el-form-item>
                </div>

            </el-form>

            <div class="footer" style="margin:0 20px;text-align:right;" v-if="isAduit">
                <el-button type="text" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
            <div class="footer" style="margin:0 20px;text-align:right;" v-else>
                <el-button type="primary" size="small" @click="isShow = false">关闭</el-button>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="isView" title="图片" width="500px" append-to-body destroy-on-close
            :close-on-press-escape="false" :close-on-click-modal="false">

            <div style="text-align: center;">
                <img :src="imgUrl" alt="" style="max-height: 150px;max-width: 400px;" />
            </div>

            <div slot="footer">
                <el-button size="small" type="primary" @click="isView = false">关闭</el-button>
            </div>
        </el-dialog>
      

    </div>
</template>

<script>

export default {
    name: "hotelManage",
    computed: {
        pagePermission() {
            return this.$store.state.pagePermission;
        },
        headers() {
            return {
                "Authorization": localStorage.getItem('Token'),
            }
        },
    },
    data() {

        return {
            map: null,
            searchForm: {
                name: "",
                status: "",
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            },
            selectTime: null,
            isLoading: false,
            tableData: [],
            total: 0,
            isShow: false,
            submitLoading: false,
            modelForm: {
                status: "",
                username: "",
                remark: ""
            },
            modelFormRules: {
                status: [{ required: true, message: "请选择审核状态", trigger: "blur" }],
                username: [{ required: true, message: "请选择关联账户", trigger: "blur" }],
                remark: [{ required: true, message: "请输入驳回备注", trigger: "blur" }],
            },

            isView: false,
            imgUrl: "",
            isAduit: false
        }
    },
    methods: {
        handleSubmit(fromName) {
            this.$refs[fromName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest('/hotelRegistration/audit', this.modelForm)
                    .then(res => {
                        this.submitLoading = false;
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success(data.msg);
                            this.isShow = false;
                            this.getTableData();
                        }
                    }).catch(() => {
                        this.submitLoading = false;
                    })
                }
            })
        },
        handleEditHotel(item) {

            this.getRequest(`/hotelRegistration/getById?id=${item.id}`)
                .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        data.data.province = data.data.province ? data.data.province : data.data.city;
                        data.data.detailDiagramUrl = data.data.detailDiagramUrl || [];
                        data.data.status = 5;
                        this.modelForm = data.data;
                        this.isShow = true;
                        this.isAduit = true;
                    }
                })
        },
        handleViewHotel(item) {
            this.getRequest(`/hotelRegistration/getById?id=${item.id}`)
            .then(res => {
                let data = res.data;
                if (data.code == 200) {
                    data.data.province = data.data.province ? data.data.province : data.data.city;
                    data.data.detailDiagramUrl = data.data.detailDiagramUrl || [];
                    this.modelForm = data.data;
                    this.isShow = true;
                    this.isAduit = false;

                }
            })
        },
        handleShowImage(item) {
            this.isView = true;
            this.imgUrl = item;
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                name: "",
                status: "",
                startDate: "",
                endDate: "",
                status: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.selectTime = '',
                this.getTableData();
        },

        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/hotelRegistration/pagingQuery", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
    },

    mounted() {
        this.getTableData();
    },

}
</script>

<style type="less">
    @import url("./index.less");
</style>